export interface AudioBus {
  enabled: boolean;
  resume: () => void;
  foot: (wet: boolean) => void;
  swing: () => void;
  hit: () => void;
  well: () => void;
}

export function createAudio(): AudioBus {
  let ctx: AudioContext | null = null;
  let lastFoot = 0;
  const ensure = () => {
    if (!ctx) ctx = new AudioContext();
    return ctx;
  };

  const blip = (f: number, t: number, type: OscillatorType, gain = 0.06) => {
    const c = ensure();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = f;
    g.gain.value = gain;
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + t);
    o.connect(g).connect(c.destination);
    o.start();
    o.stop(c.currentTime + t);
  };

  return {
    enabled: false,
    resume() {
      void ensure().resume();
      this.enabled = true;
    },
    foot(wet) {
      const now = performance.now();
      if (now - lastFoot < 280) return;
      lastFoot = now;
      if (!this.enabled) return;
      blip(wet ? 90 : 140, 0.06, "triangle", 0.03);
    },
    swing() {
      if (!this.enabled) return;
      blip(180, 0.08, "sawtooth", 0.04);
    },
    hit() {
      if (!this.enabled) return;
      blip(70, 0.12, "square", 0.07);
    },
    well() {
      if (!this.enabled) return;
      blip(48, 0.8, "sine", 0.05);
    },
  };
}
